import { useEffect, useState } from "react";
import { getDashboardDetails } from "api/dashboard";

export const useDashboardData = () => {
  const [loading, setLoading] = useState(true);
  const [selectedMeal, setSelectedMeal] = useState(null);
  const [exerciseData, setExerciseData] = useState(null);
  const [selectedMeals, setSelectedMeals] = useState(null);
  const [mindfulnessPlan, setMindfulnessPlan] = useState(null);
  const [sleepCoach, setSleepCoach] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiData = await getDashboardDetails();
        setSelectedMeal(apiData?.diet_plan);
        setExerciseData(apiData?.exercise_plan);
        setSelectedMeals(apiData?.dietPlanDataSelect);
        setMindfulnessPlan(apiData?.mindfulness_plan);
        setSleepCoach(apiData?.sleep_coach?.advice);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return {
    loading,
    selectedMeal,
    exerciseData,
    selectedMeals,
    mindfulnessPlan,
    sleepCoach,
    setMindfulnessPlan,
  };
};
